import React from 'react';
import ReactDOM from 'react-dom';
import {
    setOptions,
    overrideComponent,
    StudentPersonalInfoViewModel,
    setViewModel,
} from '@sheerid/jslib';
import { enableES5 } from 'immer';

// SheerID stuff
import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './components/StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepDocUploadComponent } from './components/StepDocUpload/StepDocUploadComponent';
import { planOfUseValidator } from './Validators/isValidPlanOfUseValidator';
import { optionalEmailValidator } from './Validators/isValidOptionalEmailValidator';
import { StepEmailLoopComponent } from './components/StepEmailLoop/StepEmailLoopComponent';
import { regionValidator } from './Validators/isValidRegion';

const defaultViewModel: StudentPersonalInfoViewModel = {
    countryChoice: {
        value: undefined,
        label: 'None',
    },
    email: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    phoneNumber: '',
    localeChoice: {
        value: 'en-US',
        label: 'en-US',
    },
    organization: {
        id: 0,
        name: '',
    },
    metadata: {
        'plan-of-use': '',
        'personal-email': '',
    },
};

setViewModel(defaultViewModel);

setOptions(defaultOptions);
googleTagManagerHook();

planOfUseValidator();
optionalEmailValidator();
regionValidator();

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
// @ts-expect-error
overrideComponent('StepEmailLoopComponent', StepEmailLoopComponent);

ReactDOM.render(<App />, document.getElementById('root'));

enableES5();
